
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from  "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { CommonUtilService } from './common.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SensorDataConverter {
	constructor(private commonUtilService: CommonUtilService){}

  filterBySensorType(sensorData, sensorType) {
			sensorData = sensorData || [];
			let filter = function(element, index, array) {
				return element.sensorTypeId == sensorType.id;
			}
			return sensorData.filter(filter);
	}

  convertData(item) {
			let result = [];
			let channels = item.channels || 1;
			if(this.commonUtilService.isArray(item.values)) {
				
				// missing packets represented by an int[] where 
				// index=2n - first missing packet index
				// index=2n+1 - missing packets count  
				let missingPackets = item.missingPackets;    
				let missingPacketIndex = 0;
				let elapsedTime = item.timestamp;
				
				let totalMissingPackets = 0;
				for(let i=0; i<missingPackets.length-1; i+=2) {
					totalMissingPackets += missingPackets[i+1];
				}
				let processedMissingPackets = 0;
				let i=0;
				let stopIndex = item.values.length + totalMissingPackets - channels;
				while(i <= stopIndex) {
					
					 if(missingPacketIndex < missingPackets.length-1
					 	&& missingPackets[missingPacketIndex] == i) {
							 
						let count = missingPackets[missingPacketIndex + 1];
						elapsedTime += count * item.sampleRate;
						missingPacketIndex += 2;
						processedMissingPackets += count;
						let values = [elapsedTime];
						for(let j=0; j<channels; j++){
							//add a gap for the chart
							values.push(null);
						}
						result.push(values);
						
						i+=count * channels;
					 }
					else {
						let values = [elapsedTime];
						for(let j=0; j<channels; j++){
							values.push(item.values[(i-processedMissingPackets*channels) + j]);
						}
						result.push(values);
						i += channels;
					}
					elapsedTime += item.sampleRate;
				}
			}
			return result;
		}

    convert(sensorData) {
			let result = [];
			sensorData.forEach(function(item, key){
				let convertedData = this.convertData(item);
				convertedData.forEach(function(value) { 
					result.push(value)
				});
			});
			return result;
		}
		
		sort(chartData){
			chartData.sort(function(o1, o2) {
				if(o1[0] != undefined && o2[0] != undefined) {
					return o1[0]-o2[0];
				}
				return 0;
			});
		}

    convertUOMValue(value, fromUOM, toUOM){
			if(fromUOM==toUOM){
				return value;
			}
			let converter = this.getUOMConverter(fromUOM, toUOM);
			if(converter==undefined){
				console.log('converter not found '+fromUOM+ '->' +toUOM);
				return value;
			}
			value = converter(value);
			return value;
		}
		
		convertUOM(data, fromUOM, toUOM){
			if(fromUOM==toUOM){
				return data;
			}
			let converter = this.getUOMConverter(fromUOM, toUOM);
			if(converter==undefined){
				console.log('converter not found '+fromUOM+ '->' +toUOM);
				return data;
			}
			
			var convertedData = [];
			data.values.forEach(function(value, index){
				convertedData.push(converter(value));
			});
			data.values=convertedData;
			return data;
		}

    converterRegistry = {
				"°C->°F": function(v){ 
					v = v * 1.8 + 32;
					return v 
				},
				"°F->°C": function(v){
					v = (v - 32) / 1.8
					return v 
				}
		};
		
		getUOMConverter(dataStreamUOM, userUOM){
			var key = dataStreamUOM + '->' + userUOM;
			return this.converterRegistry[key];
		}
}
